@use 'src/styles/variables-bundle' as *;

.ents-wishlist-price {
  display: flex;
  gap: spacer(1);

  &__value {
    white-space: nowrap;
  }

  &__container {
    margin-top: spacer(3);
  }

  &__current-price {
    color: color('coal-100');

    @include strong-s;

    @include L_and_up {
      @include strong-m;
    }

    &-reduced {
      background: color('sale');
      color: color('coal-100');
      padding: 0 spacer(1);

      @include strong-s;

      @include L_and_up {
        @include strong-m;
      }
    }
  }

  &__original-price {
    color: color('coal-100');
  }

  &__information {
    margin-top: spacer(.5);

    .ents-wishlist-price {
      &__lowest-price, &__unit-price, &__original-price {
        color: color('coal-100');

        @include text-xs;
      }
    }
  }

  @include S_and_up {
    .ents-wishlist-price {
      &__current-price {
        @include strong-m;

        &-reduced {
          @include strong-m;
        }
      }
    }
  }
}
